import { render, staticRenderFns } from "./BaseTransparentMask.vue?vue&type=template&id=46a8025f&scoped=true&"
import script from "./BaseTransparentMask.vue?vue&type=script&lang=js&"
export * from "./BaseTransparentMask.vue?vue&type=script&lang=js&"
import style0 from "./BaseTransparentMask.vue?vue&type=style&index=0&id=46a8025f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a8025f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('46a8025f', component.options)
    } else {
      api.reload('46a8025f', component.options)
    }
    module.hot.accept("./BaseTransparentMask.vue?vue&type=template&id=46a8025f&scoped=true&", function () {
      api.rerender('46a8025f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/base_components/BaseTransparentMask.vue"
export default component.exports